<div class="w-full flex flex-column overflow-hidden flex-1 flex h-full shadow-md surface-ground">
    <div class="flex justify-content-between border-bottom-1 surface-border align-items-center px-4 py-3">
        <p class="h5 font-bold">{{ 'default-cm-addUsers' | translate: 'All Users' }}</p>
        <p-dropdown
            #dropdown
            [options]="addButtonActions"
            dropdownIcon="null"
            appendTo="body"
            styleClass=" border-none dropdown-button hover:bg-primary-300 bg-primary-700 dropdown-div height-36 flex justify-content-center align-items-center w-max"
        >
            <ng-template pTemplate="selectedItem">
                <div class="flex justify-content-center align-items-center gap-2">
                    <span class="text-gray-50 text-medium font-medium">{{
                        'default-cm-addUsers' | translate: 'Add Users'
                    }}</span>
                    <img src="assets/icons/arrow-down.svg" height="20" alt="arrow down" />
                </div>
            </ng-template>
            <ng-template let-item pTemplate="item">
                <div class="flex align-items-center" (click)="triggerSelect(item, dropdown)">
                    {{ item.label | translate }}
                </div>
            </ng-template>
        </p-dropdown>
    </div>
    <div class="border-bottom-1 surface-border h-full overflow-hidden">
        <div class="flex justify-content-between align-items-center w-full border-bottom-1 surface-border">
            <app-pagination-bar
                class="w-full"
                (filtersChange)="paginationChange($event)"
                (pageSizeChange)="changePageSize($event)"
                [(filters)]="filter"
                (filtersSearch)="searchUsers()"
            ></app-pagination-bar>
        </div>
        <div class="overflow-scroll h-full pb-8">
            <p-table styleClass="radius-md" [scrollable]="true" [scrollHeight]="'flex'" [value]="usersData">
                <!-- table header start -->
                <ng-template pTemplate="header">
                    <tr class="text-sm">
                        <th>
                            <div class="relative inline pr-4">
                                {{ 'default-cm-userName' | translate: 'Username' }}
                                <span
                                    (click)="customSort('user_id')"
                                    class="absolute right-0 top-0 pr-1 cursor-pointer"
                                >
                                    @if (!sort['user_id']) {
                                        <img class="ml-2" src="assets/icons/sort-icon.svg" alt="sort" />
                                    }
                                    @if (sort['user_id'] && sortStatus === 'asc') {
                                        <img src="assets/icons/sort-asc-icon.svg" alt="sort" />
                                    }
                                    @if (sort['user_id'] && sortStatus === 'desc') {
                                        <img src="assets/icons/sort-desc-icon.svg" alt="sort" />
                                    }
                                </span>
                            </div>
                        </th>
                        <th>
                            <div class="relative inline pr-4">
                                {{ 'default-cm-bandwidth' | translate: 'Bandwidth' }}
                            </div>
                        </th>
                        <th>
                            <div class="relative inline pr-4">
                                {{ 'default-cm-remainingBandwidth' | translate: 'Remaining Bandwidth' }}
                            </div>
                        </th>
                        <th>
                            <div class="relative inline pr-4">
                                {{ 'default-cm-dailyLimit' | translate: 'Daily Limit' }}
                            </div>
                        </th>
                        <th>
                            <div class="relative inline pr-4">
                                {{ 'default-cm-remainingDailyLimit' | translate: 'Remaining Daily Limit' }}
                            </div>
                        </th>
                        <th>
                            <div class="relative inline pr-4">{{ 'default-cm-groups' | translate: 'Groups' }}</div>
                        </th>
                        <th>
                            <div class="relative inline pr-4">{{ 'default-cm-skills' | translate: 'Skills' }}</div>
                        </th>
                        <th>
                            <div class="relative inline pr-4">{{ 'default-cm-status' | translate: 'Status' }}</div>
                        </th>
                        <th>{{ 'default-cm-action' | translate: 'Action' }}</th>
                    </tr>
                </ng-template>
                <!-- table header end -->
                <!-- table body start -->
                <ng-template pTemplate="body" let-index="rowIndex">
                    <tr class="font-normal text-md cursor-pointer">
                        <td>
                            {{ usersData[index].user_id }}
                        </td>
                        <td>
                            {{ usersData[index].metadata.bandwidth }}
                        </td>
                        <td>
                            {{ usersData[index].metadata.remainingBandwidth }}
                        </td>
                        <td>
                            {{ usersData[index].metadata.dailyLimit }}
                        </td>
                        <td>
                            {{ usersData[index].metadata.remainingDailyLimit }}
                        </td>
                        <td class="gap-2 white-space-nowrap">
                            {{ usersData[index].groups | slice: 0 : 2 | join: 'group_name' }}
                            @if (usersData[index].groups && usersData[index].groups.length > 2) {
                                <span
                                    class="border-1 surface-border border-circle p-1 ml-1"
                                    [pTooltip]="tooltipContent"
                                    tooltipPosition="bottom"
                                    >+{{ usersData[index].groups.length - 2 }}</span
                                >
                            }
                            <ng-template #tooltipContent>
                                @for (item of usersData[index].groups | slice: 2; track $index) {
                                    <div class="flex align-items-center">
                                        {{ item.group_name }}
                                    </div>
                                }
                            </ng-template>
                        </td>
                        <td class="gap-2 white-space-nowrap">
                            {{ usersData[index].metadata.skills | slice: 0 : 2 | join: 'skillName' }}
                            @if (usersData[index].metadata.skills && usersData[index].metadata.skills.length > 2) {
                                <span
                                    class="border-1 surface-border border-circle p-1 ml-1"
                                    [pTooltip]="skillsTooltip"
                                    tooltipPosition="bottom"
                                    >+{{ usersData[index].metadata.skills.length - 2 }}</span
                                >
                            }
                            <ng-template #skillsTooltip>
                                @for (item of usersData[index].metadata.skills | slice: 2; track $index) {
                                    <div class="flex align-items-center">
                                        {{ item.skillName }}
                                    </div>
                                }
                            </ng-template>
                        </td>
                        <td>
                            @if (usersData[index].metadata.isActive) {
                                <p-tag severity="success" value="Active" [rounded]="true" />
                            } @else {
                                <p-tag severity="danger" value="Inactive" [rounded]="true" />
                            }
                        </td>
                        <td class="pl-4 p-2">
                            <span
                                (click)="openToggleMenu(action, usersData[index], $event)"
                                class="flex align-items-center justify-content-start border-round-sm p-1 width-20 padding-py-10 hover:bg-white hover:text-primary-700"
                            >
                                <i class="pi pi-ellipsis-v w-full h-full"></i>
                            </span>
                        </td>
                    </tr>
                </ng-template>
                <!-- table body end -->
            </p-table>
        </div>
    </div>
</div>

<p-menu
    #action
    [model]="actionsOptions"
    [popup]="true"
    styleClass="w-8rem p-0 cursor-pointer hover:surface-hover shadow-md"
>
    <ng-template pTemplate="item" let-action>
        <div class="flex w-2rem cursor-pointer gap-1 align-items-center py-3 px-3">
            <img [src]="action.icon" height="15" alt="-" />
            <span class="font-normal line-height-1">{{ action.label | translate }}</span>
        </div>
    </ng-template>
</p-menu>
